import type { CategoryContent } from '../row.js';

export const ASTRONOMY: CategoryContent = {
  bscba: [
    [
      'Wat meet parallax in de astronomie?',
      [
        'De schijnbare verschuiving van de positie van een ster',
        'De helderheidstoename van een ster door zwaartekrachtlensing',
        'De rotatieperiode van een ver sterrenstelsel',
        'De spectrale verschuiving veroorzaakt door stellaire atmosfeerbeweging',
      ],
      0,
      'Parallax is de schijnbare verschuiving van nabije sterposities ten opzichte van verre achtergrondsterren, veroorzaakt door de omloopbeweging van de aarde. Dit basislijneffect maakt afstandsmeting mogelijk.',
    ],
    [
      'Waar bevinden sterren op de hoofdreeks zich op het Hertzsprung-Russell diagram?',
      [
        'Langs een diagonale band',
        'Gegroepeerd in de rechterbovenhoek',
        'Willekeurig verspreid over het diagram',
        'Alleen langs de horizontale as',
      ],
      0,
      'Sterren op de hoofdreeks vormen een duidelijke diagonale band op HR-diagrammen, wat de massa-helderheidsrelatie weerspiegelt. Deze band weerspiegelt waterstofverbranding in sterkernen.',
    ],
    [
      'Wat is de spectrale classificatievolgorde van sterren, van heet naar koud?',
      [
        'OBAFGKM',
        'M, K, G, F, A, B, O',
        'A, B, F, G, K, M, O',
        'O, M, K, G, F, B, A',
      ],
      0,
      'De OBAFGKM-reeks ordent sterren op temperatuur en spectraaleigenschappen, van boven 25.000 K (O-type) tot onder 3.800 K (M-type).',
    ],
    [
      'Wat is de voornaamste energiebron van de zon?',
      [
        'Waterstoffusie tot helium',
        'Zwaartekrachtcontractie van het binnenste',
        'Radioactief verval van zware elementen',
        'Interactie tussen zonnewind en de magnetosfeer',
      ],
      0,
      'De zonkern zet waterstof om in helium via de proton-protonketen. Dit maakt energie vrij die onze ster al 4,6 miljard jaar voedt en dat nog ongeveer 5 miljard jaar zal blijven doen.',
    ],
    [
      'Welk type nevel wordt gevormd door heet, geïoniseerd gas rond jonge sterren?',
      [
        'Emissienevel',
        'Reflectienevel',
        'Donkere nevel',
        'Planetaire nevel',
      ],
      0,
      'Emissienevels gloeien doordat energierijke straling van nabije hete sterren het gas ioniseert. Ze lijken helder doordat ze zelf licht uitstralen in verboden atoomlijnen.',
    ],
    [
      'Wat categoriseert het Hubble-classificatiesysteem?',
      [
        'Sterrenstelselmorfologie',
        'Stellaire temperatuurbereiken',
        'Nevelsamenstellingstypes',
        'Exoplanetaire baan-eigenschappen',
      ],
      0,
      'Hubble-classificatie verdeelt sterrenstelsels op basis van hun uiterlijk in elliptische (E0–E7), spiraal- (Sa–Sc) en lenticulaire (S0) typen. Dit vormt het zogenoemde "stemvork"-diagram.',
    ],
    [
      'Welke methode verlengt afstandsmetingen voorbij parallax in de kosmische afstandsladder?',
      [
        'Cepheïde-veranderlijke sterren als standaardkaars',
        'Directe radarafstandsmeting naar alle sterrenstelsels',
        'Schijnbare helderheid vergelijken met oppervlaktetemperatuur',
        'Magnetische veldsterkte op afstand meten',
      ],
      0,
      'Cepheïden hebben een periode-helderheidsrelatie, waardoor de absolute magnitude kan worden bepaald uit de waargenomen pulsatieperiode. Dit maakt afstandsmetingen tot nabije sterrenstelsels mogelijk.',
    ],
    [
      'Wat defineert de waarnemingshorizon van een zwart gat?',
      [
        'De grens waar geen enkel object kan ontsnappen',
        'De regio waar materie botst voor het in de singulariteit valt',
        'Het zichtbare lichtoppervlak gevormd door vallend gas',
        'De buitenrand van de accretieschijf rond het zwarte gat',
      ],
      0,
      'De waarnemingshorizon is het keerpunt waar ontsnappingssnelheid de lichtsnelheid bereikt. Geen enkel signaal van binnenuit kan een externe waarnemer bereiken.',
    ],
    [
      'Wat geeft kosmologische roodverschuiving aan over verre sterrenstelsels?',
      [
        'Het universum expandeert, wat golflengtes uitrekt',
        'Verre sterrenstelsels bewegen naar ons toe met relativistische snelheden',
        'Het interstellaire medium absorbeert kortere golflengten bij voorkeur',
        'Zwaartekrachtlensing buigt licht naar het rode deel van het spectrum',
      ],
      0,
      'Kosmologische roodverschuiving ontstaat doordat ruimte-expansie golflengten uitrekt. Dit verschilt van Doppler-effect: de ruimte zelf expandeert, niet slechts de sterrenstelsels.',
    ],
    [
      'Hoe detecteren astronomen exoplaneten met de transitmethod?',
      [
        'Door de helderheidsafname tijdens transit te meten',
        'Door weerkaatst licht van het planeetoppervlak op te sporen',
        'Door het zwaartekrachtwiebelen van de moederster waar te nemen',
        'Door infraroodstraling van planeetswarmte te meten',
      ],
      0,
      'Transitfotometrie detecteert lichte helderheidsdalingen als een planeet voor haar ster passeert. Deze methode ontdekte duizenden exoplaneten en maakt atmosfeerkarakterisering mogelijk.',
    ],
    [
      'Wat is het voornaamste verschil tussen refractie- en reflectietelescopen?',
      [
        'Refractie gebruikt lenzen; reflectie gebruikt spiegels',
        'Refractie ziet ultraviolet; reflectie is beperkt tot zichtbaar licht',
        'Reflectietelescopen kunnen geen verre objecten voorbij onze sterrenstelsel zien',
        'Refractietelescopen zijn altijd groter dan reflectietelescopen',
      ],
      0,
      'Refractors gebruiken objectieflenzen om licht op focus te brengen. Reflectors gebruiken primaire spiegels. Reflectors voorkomen chromatische aberratie en staan grotere aperturen toe tegen lagere kosten.',
    ],
    [
      'Wat beperkt hoekresolutie in telescopen primair?',
      [
        'Atmosferische diffractie en lichtgolflengte',
        'De afstand tussen telescoop en waargenomen object',
        'De temperatuur van de optische componenten van de telescoop',
        'De snelheid waarmee de aarde roteert',
      ],
      0,
      'Hoekresolutie volgt de diffractielimiet: kleinere golflengte en grotere apertuur verbeteren resolutie. Atmosferische turbulentie ("seeing") verslechtert ook waarnemingen met aardse telescopen.',
    ],
    [
      'Wat is een voorbeeld van een dubbelster-stelsel?',
      [
        'Sirius A en B omlopen elkaar',
        'De zon en Jupiter omlopen elkaar',
        'Twee sterren gescheiden door lichtjaren zonder orbitale interactie',
        'Een ster en zijn omringende planetenstelsel',
      ],
      0,
      'Dubbelsterren omlopen hun gemeenschappelijke zwaartepunt. Sirius A (witte hoofdreeksster) en Sirius B (witte dwerg) vormen een wijde dubbelster met een omlooptijd van 50 jaar.',
    ],
    [
      'Wat is de geschatte massa van een neutronenster ter grootte van de aarde?',
      [
        'Ongeveer 1,4 zonnenmassa\'s',
        'Ongeveer dezelfde als de aarde (verwaarloosbaar voor stellaire massa)',
        'Ongeveer 10.000 zonnenmassa\'s',
        'Ongeveer 0,01 zonnenmassa\'s',
      ],
      0,
      'Een theelepel neutronenstermateriaal zou een miljard ton wegen. De Chandrasekhar-limiet van 1,4 zonnenmassa\'s is ongeveer het maximum voor neutronensterren.',
    ],
    [
      'Welk historisch figuur legde de wiskundige basis voor planetaire beweging?',
      [
        'Johannes Keplers drie wetten van beweging',
        'Galileo Galilei via directe telescopische waarneming',
        'Tycho Brahe door sterposities te meten',
        'Isaac Newton via zwaartekrachttheorie',
      ],
      0,
      'Keplers drie wetten (1609–1619) beschreven elliptische banen, de wet van gelijke oppervlakken en de relatie tussen omlooptijd en halve lange as. Hiermee legde hij de wiskundige basis voor de baanmechanica.',
    ],
  ],
  msc: [
    [
      'Wat definieert de Eddington-helderheidsgrens?',
      [
        'De maximale helderheid die een ster kan behouden',
        'De helderheidsdrempel om zonder instrumenten zichtbaar te zijn vanaf de aarde',
        'De relatie tussen sterkertemperatuur en oppervlaktehelderheid',
        'De snelheid waarmee een ster massa verliest via stellaire wind',
      ],
      0,
      'Eddington-helderheid treedt op wanneer stralingsdruk de zwaartekracht in evenwicht houdt, waardoor massaverlies wordt verhinderd. Voor een ster met de massa van de zon is dit ongeveer 38.000 keer de helderheid van de zon.',
    ],
    [
      'Wat is de CNO-cyclus en wanneer domineert deze?',
      [
        'Waterstof-fusiepad gekatalyseerd door koolstof, stikstof en zuurstof',
        'Een proces van kernineenstorting dat in alle massieve sterren tot een supernova leidt',
        'De heliumuitputting tot zuurstof in zeer jonge sterren',
        'Energietransportmechanisme door stellaire convectiezones',
      ],
      0,
      'De CNO-cyclus katalyseert waterstoffusie in massieve sterren waar de kerntemperatuur ~15 miljoen K overschrijdt.',
    ],
    [
      'Hoe beperkt de massa-helderheidsrelatie stellaire modellen?',
      [
        'Toetst hydrostatisch evenwicht en kernbrandingssnelheden',
        'Dit geldt alleen voor dubbelsterstelsels, niet voor individuele sterren',
        'De relatie bewijst dat alle sterren chemisch identiek zijn',
        'Dit definieert de maximale leeftijd van elke hoofdreekster',
      ],
      0,
      'De waargenomen L ∝ M³-relatie ontstaat uit hydrostatisch evenwicht, opaciteit en waterstoffusie. Afwijkingen wijzen op verschillen in stellaire leeftijd, samenstelling of structuur.',
    ],
    [
      'Wat is de Chandrasekhar-limiet en waarom is deze significant?',
      [
        'De maximale massa die een witte dwerg kan steunen',
        'De minimale massa voor heliumfusie in een ster',
        'De kerndichtheid nodig om CNO-cyclus in te stellen',
        'De helderheidsgrens tussen rode dwergen en rode reuzen',
      ],
      0,
      'Boven 1,4 zonnenmassa kan elektronendegeneratiedruk geen witte dwerg ondersteunen. Deze limiet bepaalt of een instortende kern een neutronenster of een zwart gat wordt.',
    ],
    [
      'Hoe verschilt een Kerr-zwart gat van een Schwarzschild-zwart gat?',
      [
        'Kerr-metriek bevat spin, produceert frame-dragging',
        'Kerr-zwart gat geeft Hawking-straling af; Schwarzschild niet',
        'Kerr-zwarte gaten hebben geen waarnemingshorizon, dus waarneembaar',
        'Alleen Kerr-zwarte gaten kunnen materie toevoegen en jets voortbrengen',
      ],
      0,
      'Kerr-zwarte gaten roteren, wat een spinparameter toevoegt aan de metriek. Dit creëert een ergosfeer en verkleint de straal van de waarnemingshorizon ten opzichte van het niet-roterende geval.',
    ],
    [
      'Wat is het onderscheid tussen kosmologische en Doppler-roodverschuiving?',
      [
        'Kosmologisch door ruimte-expansie; Doppler door beweging',
        'Kosmologisch geldt alleen voor achtergrondmicrowave-straling',
        'Dit zijn identieke verschijnselen bekeken op verschillende schaal',
        'Doppler groeit oneindig met afstand; kosmologisch niet',
      ],
      0,
      'Kosmologische roodverschuiving rekt alle golflengten uit door expansie (z = a(t₀)/a(tₑₘᵢₜ) − 1). Doppler hangt af van de snelheidscomponent langs de gezichtslijn.',
    ],
    [
      'Wat stelt de viriaalstelling voor zwaartekrachtgebonden stelsels?',
      [
        '2K + U = 0, twee keer kinetische plus potentiële energie',
        'Totale energie is altijd positief, wat instorting van de ster verhindert',
        'Potentiële en kinetische energie zijn gelijk maar tegengesteld',
        'Zwaartekrachtstelsels bereiken noodzakelijk oneindige dichtheid',
      ],
      0,
      'De viriaalstelling beperkt het stellaire evenwicht: als de zwaartekracht toeneemt, moeten dichtheid en temperatuur stijgen om 2K + U = 0 te behouden.',
    ],
    [
      'Wat is de Hertzsprung-kloof en wat stelt deze voor?',
      [
        'Een dunbevolkte regio tussen de hoofdreeks en de reuzentak',
        'Een kloof in spectrale classificatie door overlappende temperatuurbereiken',
        'De afstand tussen dichtste en verste waarneembare sterren',
        'Een discontinuïteit in sterkleur door atmosfeerionisatietransities',
      ],
      0,
      'De Hertzsprung-kloof is een dunbevolkte regio waar geëvolueerde sterren snel overgaan van de hoofdreeks naar de reuzentak.',
    ],
    [
      'Wat kenmerkt de structuur en evolutie van asymptotic giant branch (AGB)-sterren?',
      [
        'Lage tot intermediaire massa met inerte koolstof-zuurstofkernen',
        'De uiteindelijke stabiele staat van alle sterren, voor altijd onveranderd',
        'Massieve sterren vlak voor kernineenstorting en supernova',
        'Sterren zonder nucleair brandstof, beginnend af te koelen als witte dwergen',
      ],
      0,
      'AGB-sterren branden waterstof in de buitenste schil en helium in een intermediaire schil rond de C-O-kern. Thermale pulsen veroorzaken episodische massaverlies.',
    ],
    [
      'Hoe stelt zwaartekrachtlensing kosmologische toepassingen in staat?',
      [
        'Massieve structuren buigen licht, vergroten verre objecten',
        'Lensing vergroot altijd, dus zwakke sterrenstelsels lijken helderder dan werkelijk',
        'Lensing treedt alleen rond zwarte gaten op, geen praktische toepassing',
        'Lensing meet chemische samenstelling van tussenliggende gaswolken',
      ],
      0,
      'Sterke lensing creëert meerdere beelden, terwijl zwakke lensing subtiel vervormt. Beide vormen onderzoeken donkere materie en onthullen verre, sterk roodverschoven sterrenstelsels.',
    ],
    [
      'Wat is eigenbeweging en hoe verschilt dit van parallax?',
      [
        'Eigenbeweging is hoekbeweging; parallax is orbitale verschuiving',
        'Eigenbeweging geldt alleen nabije sterren; parallax voor verre',
        'Eigenbeweging vereist ruimtetelescopen; parallax alleen grondgesteld',
        'Dit zijn identieke metingen uitgedrukt in verschillende eenheden',
      ],
      0,
      'Eigenbeweging (μ, boogsec/jaar) weerspiegelt intrinsieke sterbeweging; parallax (p) is puur geometrisch. De afstand d = 1/p parsec vereist beide.',
    ],
    [
      'Wat beperkt nauwkeurigheid van stellaire parallaxmetingen en hoe werd dit overwonnen?',
      [
        'Turbulentie beperkt parallax; ruimtetelescopen bereiken microboogsec',
        'Parallax werkt alleen voor sterren < 10 lichtjaar door fysische wet',
        'Alleen gereflecteerd licht, niet direct sterlicht, toont meetbare parallax',
        'Interstellair stof obscureert volledig parallaxsignalen voor verre sterren',
      ],
      0,
      'Grondgebaseerde parallax is beperkt tot ~100 pc; Hipparcos bereikt ~10 pc; Gaia meet nu microboogsec-precisie tot ~10 kpc.',
    ],
    [
      'Hoe wordt spectroscopische informatie gebruikt voor stellaire eigenschappen?',
      [
        'Spectraallijnen tonen samenstelling en temperatuur',
        'Spectroscopie meet alleen schijnbare helderheid',
        'Spectra tonen rechtstreeks sterinterieurdichtheid zonder modellen',
        'Spectroscopie kan niet tussen absorptie en emissie onderscheiden',
      ],
      0,
      'Spectrale absorptielijnen ontstaan in koele buitenlagen; emissielijnen in heet gas. De lijnsterkte hangt af van temperatuur en dichtheid; Doppler-shift codeert kinetiek.',
    ],
    [
      'Wat is de periode-helderheidsrelatie voor Cepheïden en de astronomische betekenis?',
      [
        'Langere Cepheïden zijn helderder',
        'De relatie geldt alleen voor een minderheid van sterren en heeft beperkt nut',
        'Dit bewijst alle Cepheïden dezelfde intrinsieke helderheid hebben',
        'Periode-helderheid treedt alleen op in dubbelstelsels',
      ],
      0,
      'Cepheïden gehoorzamen aan log P = a log M + b, wat ze tot "standaardkaarsen" maakt. Hubble gebruikte dit om te bewijzen dat Andromeda een sterrenstelsel is.',
    ],
    [
      'Wat is de Tully-Fisher-relatie en welke rol speelt deze in de kosmologie?',
      [
        'Sterrenstelselhelderheid correleert met rotatiesnelheid',
        'Dit is puur theoretisch zonder observatietoepassing',
        'Relatie geldt gelijk voor alle sterrenstelseltypes inclusief elliptisch',
        'Dit meet sterrenstelsleeftijd door stellaire kleur',
      ],
      0,
      'De Tully-Fisher-relatie (L ∝ v⁴, ongeveer) breidt de afstandsmeting uit tot ~100 Mpc, als aanvulling op de Cepheïde- en SN Ia-methoden.',
    ],
  ],
  phd: [
    [
      'In de Kerr-metriek, wat is de ergosfer en fysieke betekenis?',
      [
        'Regio met Penrose-energie-extractie buiten de horizon',
        'Singulariteit in zwartgatcentrum met oneindige dichtheid',
        'Regio waar frame-dragging verwaarloosbaar wordt',
        'Waarnemingsartefact van Doppler-effect rond roterend object',
      ],
      0,
      'In de ergosfeer (tussen de horizonten) roteert de ruimte zelf mee met het zwarte gat. Het Penrose-proces kan rotatie-energie onttrekken en zo de spin verminderen.',
    ],
    [
      'Wat is het mechanisme van stralingsinefficiënte accretiestromen en welke rol spelen ze in AGN-feedback?',
      [
        'Lage-accretiesnelheid-systemen waar jets feedback domineren',
        'Zeer heldere accretietoestanden waarin stralingsdruk de uitstroming domineert',
        'Accretiestromen waar energie geheel zichtbaar spectrum uitstraalt',
        'Systemen waar accretiefrequentie Eddington-limiet miljoen keren overschrijdt',
      ],
      0,
      'In stralingsinefficiënte accretie advecteert de massa inwaarts met lage efficiëntie. Jets zetten momentum af in het ICM, waardoor vorming wordt onderdrukt.',
    ],
    [
      'Welke beperkingen stellen pulsartimingmatrices op zwaartekrachtgolfachtergronden?',
      [
        'Timingirregulariteiten van zwartgatdubbels geven laagfrequente golven',
        'Pulsars stralen zwaartekrachtgolven direct uit, ongeschikt voor detectie',
        'Alleen geïsoleerde superzware zwarte gaten geven detecteerbare golfstraling af',
        'Pulsartiming kan golffrequenties beneden 100 Hz niet beperken',
      ],
      0,
      'PTA\'s detecteren nanohertz-golven van de samenvoeging van superzware zwarte gaten via timingresten van veel pulsars. IPTA-gegevens suggereren een stochastische achtergrond.',
    ],
    [
      'Hoe beïnvloeden metalliciteitsafhankelijke stellaire evolutiemodellen de leeftijdsinterpretatie van globulaire clusters?',
      [
        'Lagere metalliciteit clusters hebben verschillende evolutiesnelheden',
        'Metalliciteit heeft verwaarloosbaar effect op stellaire evolutie',
        'Alle globulaire clusters hebben identieke metalliciteit ongeacht formatie',
        'Metalliciteit beïnvloedt alleen stellaire kleur, niet evolutierates',
      ],
      0,
      'Lage-[Fe/H]-sterren branden waterstof langzamer en evolueren anders, wat een verschuiving in de isochrone-fit veroorzaakt. Blauwe horizontale takken vereisen een voorzichtige scheiding tussen leeftijd en metalliciteit.',
    ],
    [
      'Wat zijn populatiesynthesemodellen en hoe beperken ze de stervormingsgeschiedenis?',
      [
        'PSM\'s combineren evolutiepaden met IMF-aannamen voor spectra',
        'Populatiesynthese kan niet op sterrenstelsels voorbij 100 Mpc worden toegepast',
        'Deze modellen werken alleen voor eenmalige stervorming, niet continue SFR',
        'PSM\'s meten sterrenstelsleeftijd direct uit fotometrische roodverschuiving',
      ],
      0,
      'PSM-fitting aan multi-golflengtegegevens (UV tot IR) ontwarrt leeftijd, stof en vormingsgeschiedenis. Bayesiaanse gevolgtrekking herwint de vormingsgeschiedenis uit waarschijnlijkheidsverdelingen.',
    ],
    [
      'Wat zijn stellaire oscillatiemodes (p, g, f) en waarom zijn ze wetenschappelijk waardevol?',
      [
        'Akoestische modes (p) door druk; gravitatiemodes (g) door drijfvermogen',
        'Alle stellaire oscillaties zijn identiek en kunnen interne structuur niet onderscheiden',
        'Oscillatiemodes treden alleen in witte dwergen op',
        'Oscillatiefrequentie is onafhankelijk van stellaire eigenschappen',
      ],
      0,
      'p-modes propageren door convectieve mantels; g-modes door stralingskernen. Modefrequenties (Δν, νmax) meten direct de kernmassa, leeftijd en menging uit waarnemingen.',
    ],
    [
      'Hoe beperkt variatie in stofextinctiewetten de eigenschappen van stofkorrels?',
      [
        'Verschillende extinctiecurven (Rᵥ) geven korrelgrootteverspreiding',
        'Extinctie is onafhankelijk van stofeigenschappen en volgt overal dezelfde wet',
        'Extinctiecurven gelden alleen voor nabij stof; ver stof kan niet worden gekarakteriseerd',
        'Korrelgrootte heeft geen meetbaar effect op extinctiegolflengte',
      ],
      0,
      'Rᵥ = Aᵥ / E(B−V) varieert van ~2,5 (diffuse ISM) tot ~5 (dichte regio\'s). Kleine korrels veroorzaken steile UV-extinctie; grote korrels veroorzaken vlakkere extinctie.',
    ],
    [
      'Hoe wordt kleurexces bepaald en hoe worden roodverkleuringsvectorcorrecties toegepast in fotometrie?',
      [
        'E(B−V) uit intrinsieke kleuren; correctie volgt de roodverkleuringsvector',
        'Kleurexces is het verschil tussen waargenomen en catalogusgroottes',
        'Roodverkleuringsvectoren zijn radiale lijnen vanaf de intrinsieke kleur in de kleur-kleurruimte',
        'Kleurexces is onafhankelijk van stofeigenschappen en kan genegeerd worden',
      ],
      0,
      'E(B−V) kwantificeert het stof langs de gezichtslijn. De roodverkleuringsvector volgt de extinctiecurve, niet een radiale richting. Dit is belangrijk voor nauwkeurige temperatuur- en helderheidsterugwinning.',
    ],
    [
      'Wat is de Hubble-spanning en welke voorgestelde oplossingen staan ter discussie?',
      [
        '~4σ verschil tussen vroege en late H₀-metingen',
        'Een geringe 1σ onenigheid over kosmische parameters opgelost door grotere onderzoeken',
        'Bewijs dat universum niet expandeert',
        'Onenigheid alleen binnen Planck-samenwerking en opgelost door andere experimenten',
      ],
      0,
      'H₀ ≈ 67 km/s/Mpc (Planck) vs. ≈73 (SH0ES). Vroege donkere energie en evoluerende-w-modellen zijn actieve theoretische voorstellen.',
    ],
    [
      'Hoe beperken snel radiobursts kosmische parameters en fysicamodellen?',
      [
        'FRB-dispersie meet elektronendichtheid en beperkt H₀',
        'Snel radiobursts zijn alleen galactische oorsprong zonder kosmische betekenis',
        'FRB\'s meten alleen universumleeftijd',
        'Alle FRB\'s worden verklaard door pulsars in ons sterrenstelsel',
      ],
      0,
      'Dispersiemaat DM geeft de elektronenkolomdichtheid weer; DM/z onderzoekt IGM-ionisatie. Magnetarmodellen beperken magnetische veldsterktes en de plasmafysica.',
    ],
    [
      'Wat is het huidige begrip van het coronaalverhittingsprobleem in de zonnefysica?',
      [
        'Coronale temperatuur overschrijdt fotosfeer via golven en herverbinding',
        'Corona is altijd koeler dan fotosfeer, in tegenspraak met oudere waarnemingen',
        'Coronaalverwarming wordt verklaard door alleen zwaartekrachtpotentiaalenergie',
        'Alle theoretische modellen stemmen over enkele verwarmingsmechanisme',
      ],
      0,
      'De coronaalverhittingsparadox blijft bestaan: golven en herverbinding zijn experimenteel ondersteund, maar lusopwarming blijft onvolledig begrepen.',
    ],
    [
      'Wat zijn ultrahogenergie kosmische stralen (UHECR) en welke oorsprong wordt volgens de theorie het meest waarschijnlijk geacht?',
      [
        'Kosmische stralen >5×10¹⁹ eV; AGN-jets zijn topkandidaten',
        'Kosmische stralen onder 10¹⁸ eV afkomstig van zon',
        'Alleen galactische supernovae kunnen hoogenergie-straling voortbrengen',
        'UHECR\'s zijn puur theoretisch zonder detecties boven 10¹⁰ eV',
      ],
      0,
      'GZK-afsnijding van pionproductie op CMB-fotonen beperkt de propagatie. Pierre Auger-gegevens bevorderden een extragalactische (vooral AGN) oorsprong voor E > 10¹⁹ eV.',
    ],
    [
      'Wat onthullen zwaartekrachtgolfpolarisatiehandtekeningen over tests van aangepaste zwaartekracht?',
      [
        'Tensormodes domineren in GR, andere modes onderdrukt',
        'Zwaartekrachtgolven hebben slechts één polarisatietoestand',
        'Aangepaste zwaartekrachttheorieën voorspellen identieke polarisaties aan GR',
        'Polarisatiemetingen kunnen theorieën voorbij GR niet testen',
      ],
      0,
      'LIGO/Virgo-gegevens uit de samenvoeging van zwarte gaten en van neutronensterren beperken de polarisatie-inhoud: tensor domineert; scalair/vector <10% (90% CL).',
    ],
    [
      'Wat is reverberatiebepaling en hoe meet dit zwartgatmassa\'s in AGN?',
      [
        'Vertraging tussen brede-lijn en continuüm geeft M_BH',
        'Reverberatiebepaling werkt alleen voor radiogalaxieën',
        'Dit observeert rechtstreeks de waarnemingshorizon',
        'Lijnvertragingen zijn onafhankelijk van zwartgatmassa',
      ],
      0,
      'Tijdvertraging Δt ∝ r; snelheid uit Doppler-breedte geeft τ ~ GM_BH / c² equivalent. Honderden AGN zijn gemeten; onzekerheid in de hoek en de f-factor blijft bestaan.',
    ],
    [
      'Wat onthullen de eigenschappen van quasar-absorptiesystemen over IGM/CGM-fysica?',
      [
        'Metaal/Lyman-absorptie in QSO-spectra beperkt HI',
        'Quasar-absorptie is geheel door stof nabij QSO-gastheer',
        'Absorptiesystemen bestaan alleen binnen gastheersterrenstelsel',
        'Deze systemen hebben geen verband met kosmische baryoncyclus',
      ],
      0,
      'DLA\'s (log NHI > 20,3) zijn stervormingsplaatsen. Boswolken (NHI ~ 10¹² cm⁻²) volgen de structuur. Metaalstoffen helpen bij het onderzoeken van hete filamenten en feedback.',
    ],
  ],
  professor: [
    [
      'Wat is het informatieprobleem in zwartgat-thermodynamica en wat zijn de belangrijkste theoretische oplossingen?',
      [
        'Hawking-verdamping verliest informatie; snaartheorie kan dit oplossen',
        'Informatieprobleem is definitief opgelost en niet meer betwist tussen experts',
        'Kwantummechanica moet verlaten worden om het probleem op te lossen',
        'Zwarte gaten verdampen niet en het probleem is puur hypothetisch',
      ],
      0,
      'Hawkings berekening impliceert informatieverlies, in strijd met unitariteit. Snaartheorie suggereert 2^(A/4) microtoestanden, terwijl de vuurmuurhypothese een Planck-schaalstructuur voorstelt.',
    ],
    [
      'Wat zijn waarnemings- en theoretische implicaties van aangepaste zwaartekrachttheorieën zoals MOND en f(R)?',
      [
        'MOND wijzigt Newtons wet bij lage versnelling; f(R) wijzigt de meetkunde',
        'Aangepaste zwaartekrachttheorieën zijn experimenteel uitgesloten en verlaten',
        'MOND en donkere materie zijn waarnemingsgelijk aan alle schalen',
        'Aangepaste zwaartekracht voorspelt identieke voorspellingen aan GR',
      ],
      0,
      'MOND (a₀ ≈ 10⁻¹⁰ m/s²) past rotatiecurven aan, maar faalt bij clusters en lensing. f(R) heeft hetzelfde probleem. CMB en sterke lensing bevoordelen GR in combinatie met donkere materie.',
    ],
    [
      'Hoe beperken grootschalige-structuursimulaties met baryonische akoestische oscillaties de donkere energie?',
      [
        'BAO van sterrenstelselbundeling verstrekt een standaardlineaal',
        'Grootschalige structuur kan donkere energie niet beperken',
        'BAO-metingen gelden alleen voor lokaal universum',
        'Alle donkere-energiemodellen produceren identieke BAO-voorspellingen',
      ],
      0,
      'De BAO-schaal van de geluidshorizon legt ruwe oscillaties vast in de materieverdeling. DESI en BOSS meten BAO op meerdere roodverschuivingen; gecombineerd met CMB beperken deze w(a).',
    ],
    [
      'Wat onthullen intergalactische-magnetischeveldbeperkingen (IGMF) uit TeV-gammastralingsobservaties?',
      [
        'TeV-fotoncascades creëren een halo die IGMF beperkt',
        'Intergalactische magnetische velden zijn onmeetbaar en onbeperkt',
        'Alleen grondgestelde radioastronomie kan IGMF meten',
        'IGMF-sterkte is identiek aan galactische velden overal',
      ],
      0,
      'Fermi LAT en Cherenkov-telescopen observeren vertraagde cascade-emissie. IGMF ~0,1–1 nG wordt afgeleid uit niet-detectie; de oorsprong van het zaadveld blijft een open vraag.',
    ],
    [
      'Wat zijn exotische compacte objecten (gravastars, bosonsterren, donkermateria-kernen) en welke tests bestaan hiervoor?',
      [
        'Alternatieven voor zwarte gaten met singulariteitsvrij interieur, getest via GW-echo\'s',
        'Alle compacte objecten voorbij neutronensterren moeten zwarte gaten zijn beproven wiskundig',
        'Exotische compacte objecten zijn puur speculatief zonder waarnemingsrelevantie',
        'Deze objecten zouden niet te onderscheiden zijn van zwarte gaten',
      ],
      0,
      'Gravastars hebben een omkering van stress-energie in het interieur; bosonsterren graviteren zelf via een scalair veld. Er wordt gezocht naar echo-handtekeningen in gravitatiegolfdata na een samensmelting.',
    ],
    [
      'Wat onthullen multibericht-waarnemingen van IceCube over kosmische versnellers in de neutrinoastronomie?',
      [
        'IceCube-neutrino\'s traceren deeltjesversnelling in jets',
        'Neutrino\'s zijn te zwak-wisselwerkend om van astrofysische bronnen waargenomen te worden',
        'Neutrino-astronomie bestudeert alleen zonneneutrino\'s',
        'Alle neutrino-gebeurtenissen in IceCube stammen uit aardse atmosfeer',
      ],
      0,
      'IceCube detecteert jaarlijks ~100 TeV–PeV neutrino\'s; de blazar TXS 0506+56 werd in 2017 gelinkt aan een neutrino. Neutrino\'s ontsnappen aan dichte regio\'s en onthullen zo het interieur van jets.',
    ],
    [
      'Welke fysische mechanismen drijven snelle-radioburst-emissie in vooraanstaande magnetarmodellen?',
      [
        'Magnetische herverbinding in magnetar-magnetosferen',
        'Snel radiobursts zijn bevestigd pulsars in ons sterrenstelsel',
        'Alle FRB-modellen vereisen zwarte gaten in de bron',
        'Uitstralingmechanisme is identiek aan supernova-resten',
      ],
      0,
      'Magnetarmodellen stellen dat een plotselinge herschikking van het magnetisch veld Alfvén-golven en magnetische herverbinding veroorzaakt. Herhalende FRB\'s (zoals FRB 180916, met een SGR-achtige bron) ondersteunen dit.',
    ],
    [
      'Wat onthullen huidige onderzoeken over circumgalactisch medium en gastoevoer in sterrenstelsels?',
      [
        'UV-absorptie toont gasmantels zijn heet en metaalrijk',
        'Circumgalactisch medium is leeg en speelt geen rol in evolutie',
        'Al het gas in sterrenstelsels is afkomstig van intergalactisch medium zonder hergebruik',
        'Sterrenstelsel-mantels zijn te heet voor neutraal gas',
      ],
      0,
      'COS/HST-onderzoeken brengen Lyα, CIV, OVI en MgII tot op 200+ kpc in kaart. Hete mantels coëxisteren met koude stromen; feedback-uitstromingen (Mg II) zijn alomtegenwoordig.',
    ],
    [
      'Welke stervormingsuitbarsting-feedbackmechanismen drijven de uitdoving van stervorming?',
      [
        'Supernovae en AGN drijven uitstromingen aan die gas verwijderen en onderdrukken',
        'Ontploffing-feedback is verwaarloosbaar vergeleken zwaartekracht in evolutie',
        'Alle sterrenstelsels stellen stervorming tegelijk stil op vaste kosmische tijd',
        'Feedback heeft geen effect op sterrenstelselmetalliciteit',
      ],
      0,
      'SN-aangestuurde winden schalen als η ~ (σ/v_wind)^α; AGN-feedback domineert in massieve elliptische sterrenstelsels boven M_* ~ 10¹¹ M⊙. Modellen vereisen η > 1.',
    ],
    [
      'Wat zeggen huidige beperkingen op de donkere-energietoestandsvergelijking over kosmische modellen?',
      [
        'w(a)-gegevens zijn consistent met Λ maar niet uniek',
        'Donkere energie is definitief bewezen kosmologische constante',
        'Alle donkere-energiemodellen doen identieke voorspellingen',
        'Huidige waarnemingen sluiten alle alternatieven voor de constante uit',
      ],
      0,
      'Planck + SNe + BAO + zwakke lensing geven w ∈ [−1,08, −0,90] op 68% CL. DESI wijst op mogelijke w(z)-evolutie; vroege-DE-modellen kunnen helpen bij de H₀-spanning.',
    ],
    [
      'Wat onthullen getijuitrukking-gebeurtenissen over superzware-zwartgatdemografie en accretiefysica?',
      [
        'Een ster die de getijstraal kruist wordt verscheurd',
        'Getijuitrukking is puur theoretisch zonder bevestigde waarnemingen',
        'Al getijuitrukking leidt tot volledige zwartgatsamenvoeging',
        'Getijgebeurtenissen treden alleen op rond zwarte gaten met stellaire massa',
      ],
      0,
      'X-ray-transiënten (ASASSN-14li) tonen TDE-handtekeningen: thermische UV en zachte röntgenstraling, superlineaire stijging. ATLAS/ZTF detecteren tientallen; spectroscopie beperkt de spin.',
    ],
    [
      'Wat beperken recente waarnemingen over primitieve zwaartekrachtgolven en inflatiemodellen?',
      [
        'CMB B-mode-polarisatie beperkt r tot < 0,04, wat inflatiemodellen beperkt',
        'Primitieve zwaartekrachtgolven zijn definitief waargenomen en inflatie bewezen',
        'Inflatie is volledig uitgesloten door huidige gegevens',
        'Geen kosmologisch model voorspelt gravitatiegolven van vroeg universum',
      ],
      0,
      'Planck r-limiet sluit eenvoudige modellen uit (Λφ⁴); tensor-modes van inflatie hebben f ∝ k. Het IPTA-signaal past bij voorspellingen van kosmische snaren of faseovergangen.',
    ],
    [
      'Wat is de fysische oorsprong en waarnemingshandtekening van microlensing door compacte objecten en planeten?',
      [
        'Microlensing vergroot verre bronnen via compacte lenzen',
        'Microlensing is niet te onderscheiden van ander lensing',
        'Alleen superzware zwarte gaten kunnen als microlensen fungeren',
        'Microlensing kan planeten niet detecteren',
      ],
      0,
      'Microlensing-onderzoeken (OGLE, MOA) detecteren planeten via causticovergangen; koude Jupiters voorbij 2,5 AU zijn algemeen. De Einstein-ringtijd tₑ ~ 30 d geeft massa en afstand weer.',
    ],
    [
      'Wat onthullen quasar-absorptielinnen en Lyman-alpha-bos over feedback en herontionisatie?',
      [
        'Gedempte Lyman-alfa-systemen en het bos beperken herontionisatie',
        'Absorptiesystemen bevatten geen informatie over sterrenstelsel-feedback',
        'Herontionisatie was onmiddellijk en uniform over universum',
        'Metalabundanties zijn onafhankelijk van stervorming',
      ],
      0,
      '[X/H] in DLA\'s traceert de stervormingsgeschiedenis en metaalverliestijdschalen (τ ~ Gyr). De doorgelaten flux in het Lyman-alfa-bos bij z > 6 beperkt τᵣₑᵢₒₙ.',
    ],
    [
      'Hoe beperken de architecturen van extrasolaire planetenstelsels (resonanties, onderlinge inclinaties, gaten) vormings- en migratiemodellen?',
      [
        'Resonanties wijzen op migratie; excentriciteiten op verstrooiing',
        'Planetenstelsel-architecturen zijn willekeurig en houden geen verband met vorming',
        'Alle exoplanet-stelsels zijn identiek in structuur',
        'Migratie is onmogelijk en speelt geen rol in stelselsamenbouw',
      ],
      0,
      'TRAPPIST-1 toont een resonante keten die wijst op schijfmigratie. HR 8799 heeft een onderlinge hoek van ~20°, wat wijst op N-lichaamverstrooiing. Gaten in puinschijven (Fomalhaut, β Pic) tonen rechtstreeks afgebeelde planeten.',
    ],
  ],
};
